import { render, staticRenderFns } from "./ManualAddress.vue?vue&type=template&id=05ddec80"
import script from "./ManualAddress.vue?vue&type=script&lang=js"
export * from "./ManualAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports